exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".zEFSdw_-ZqCSyP3B2gtcn{height:400px;display:flex;flex-direction:column;justify-content:center;align-items:center;color:#757575}.zEFSdw_-ZqCSyP3B2gtcn span{color:#fff;margin-bottom:20px}.zEFSdw_-ZqCSyP3B2gtcn a{max-width:210px;font-size:13px;line-height:16px}\n", ""]);

// Exports
exports.locals = {
	"emptyContainer": "zEFSdw_-ZqCSyP3B2gtcn"
};